import * as actions from './actions';
import reducer from './reducer'
import * as selectors from './selectors';

export {default as Home} from "./home/home";
export {default as Body} from "./body/body";

export default {actions, reducer, selectors};